import React from 'react'
import Fa from 'react-fontawesome'
import TimePicker from 'rc-time-picker'
import moment from 'moment';
import "rc-time-picker/assets/index.css"

const format = ('HH:mm:ss');


export default class ScheduleBox extends React.Component {



  constructor(props) {
    super(props)

    var editing = false
    var newItem = false

    if (this.props.singleItem.id > 100000) {
        editing = true
        newItem = true
    }



    this.state = { 
                 editing: editing,
                 newItem: newItem,
                 id: this.props.singleItem.id,
                 hb: this.props.singleItem.heartbeat_value,
                 hf: this.props.singleItem.hour_from,
                 ht: this.props.singleItem.hour_to,
                 monday: this.props.singleItem.monday,
                 tuesday: this.props.singleItem.tuesday,
                 wednesday: this.props.singleItem.wednesday,
                 thursday: this.props.singleItem.thursday,
                 friday: this.props.singleItem.friday,
                 saturday: this.props.singleItem.saturday,
                 sunday: this.props.singleItem.sunday,
                 
                
                }
  }
 

    editToggle(){
        this.setState({editing: !this.state.editing})
    }

    accept() {
        let date1 = new Date()
        let date2 = new Date()
        date2.setFullYear(date2.getFullYear()+10)
        this.props.onFinishEdit(
            {index: this.props.index,id: this.state.id, heartbeat_value: this.state.hb, hour_from: this.state.hf, 
                hour_to: this.state.ht, monday: this.state.monday, tuesday: this.state.tuesday, 
                wednesday: this.state.wednesday, thursday: this.state.thursday, friday: this.state.friday, 
                saturday: this.state.saturday, sunday: this.state.sunday, period_from: date1, period_to: date2
            })
        this.setState({editing: false})
    }

    cancel(){
        if (this.state.newItem) {
            this.props.delete(this.props.index)
        }        
        else {
            this.setState(this.getInitialState())

        }

    }

    handleHb(event) {
        this.setState({hb: event.target.value })
    }
    handleHf(value) {
        this.setState({hf: value && value.format(format) })
    }
    handleHt(value) {
        this.setState({ht: value && value.format(format) })
    }
    daySelect(event) {
        this.setState({[event.target.name]: event.target.checked })
    }

    render () {

        var repeat = <span>
                        <span className={this.state.monday ? 'day-active': 'day-inactive'}>Mon</span>
                        <span className={this.state.tuesday ? 'day-active': 'day-inactive'}>Tue</span>
                        <span className={this.state.wednesday ? 'day-active': 'day-inactive'}>Wed</span>
                        <span className={this.state.thursday ? 'day-active': 'day-inactive'}>Thu</span>
                        <span className={this.state.friday ? 'day-active': 'day-inactive'}>Fri</span>
                        <span className={this.state.saturday ? 'day-active': 'day-inactive'}>Sat</span>
                        <span className={this.state.sunday ? 'day-active': 'day-inactive'}>Sun</span>
                    </span>

        var repeatSel = <span>
                        <span className={this.state.monday ? 'day-active': 'day-inactive'}>
                            <input type="checkbox" checked={this.state.monday} name="monday" onChange={(e) => this.daySelect(e)} /><br/>Mon</span>
                        <span className={this.state.tuesday ? 'day-active': 'day-inactive'}>
                            <input type="checkbox" checked={this.state.tuesday} name="tuesday" onChange={(e) => this.daySelect(e)} /><br/>Tue</span>
                        <span className={this.state.wednesday ? 'day-active': 'day-inactive'}>
                            <input type="checkbox" checked={this.state.wednesday} name="wednesday" onChange={(e) => this.daySelect(e)} /><br/>Wed</span>
                        <span className={this.state.thursday ? 'day-active': 'day-inactive'}>
                            <input type="checkbox" checked={this.state.thursday} name="thursday" onChange={(e) => this.daySelect(e)} /><br/>Thu</span>
                        <span className={this.state.friday ? 'day-active': 'day-inactive'}>
                            <input type="checkbox" checked={this.state.friday} name="friday" onChange={(e) => this.daySelect(e)} /><br/>Fri</span>
                        <span className={this.state.saturday ? 'day-active': 'day-inactive'}>
                            <input type="checkbox" checked={this.state.saturday} name="saturday" onChange={(e) => this.daySelect(e)} /><br/>Sat</span>
                        <span className={this.state.sunday ? 'day-active': 'day-inactive'}>
                            <input type="checkbox" checked={this.state.sunday} name="sunday" onChange={(e) => this.daySelect(e)} /><br/>Sun</span>
                    </span>

        if (this.state.editing) {

        // var hf = new Date(this.props.singleItem.hour_from)
        // var ht = this.props.singleItem.hour_to.split('T')[1]
        // console.log(ht)
        // //var ht = '11:12:21'

            return (
                <div className='row schedule-box editing'>
                    <div className="col-md-9">

                        <div className="inline">
                            <div className="lbl">#</div>
                            <div>{this.props.index}</div>
                        </div>
                        <div className="inline">
                            <div className="lbl"><Fa name='heartbeat' />&nbsp;Heartbeat</div>
                            <div><input type="number" className="hb-input" defaultValue={this.state.hb} onChange={(e) => this.handleHb(e)}/>s</div>
                        </div>
                        <div className="inline">
                            <div className="lbl"><Fa name='clock-o' />&nbsp;Time from</div>
                            <TimePicker style={{width:50}} showSecond={false} defaultValue={moment(this.state.hf,format)} onChange={(e) => this.handleHf(e)} />
                        </div>
                        <div className="inline">
                            <div className="lbl"><Fa name='clock-o' />&nbsp;Time to</div>
                            <TimePicker  style={{width:50}} showSecond={false} defaultValue={moment(this.state.ht,format)} onChange={(e) => this.handleHt(e)} />
                        </div>
                        <div className="inline">
                            <div className="lbl"><Fa name='repeat' />&nbsp;Repeat</div>
                            <div style={{minWidth:300}}>{repeatSel}</div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <button className="btn btn-xs btn-danger pull-right" style={{marginLeft: 10, marginTop: 5 }}  onClick={() => this.cancel()}><Fa name="times"/>&nbsp;Cancel</button>
                        <button className="btn btn-xs btn-default pull-right" style={{marginLeft: 10, marginTop: 5 }} onClick={() => this.accept()}><Fa name="check"/>&nbsp;Accept</button>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className='row schedule-box'>
                    <div className="col-md-9">
                        <div className="inline">
                            <div className="lbl">#</div>
                            <div>{this.props.index}</div>
                        </div>
                        <div className="inline">
                            <div className="lbl"><Fa name='heartbeat' />&nbsp;Heartbeat</div>
                            <div>{this.state.hb}s</div>
                        </div>
                        <div className="inline">
                            <div className="lbl"><Fa name='clock-o' />&nbsp;Time from</div>
                            <div>{this.state.hf}</div>
                        </div>
                        <div className="inline">
                            <div className="lbl"><Fa name='clock-o' />&nbsp;Time to</div>
                            <div>{this.state.ht}</div>
                        </div>
                        <div className="inline">
                            <div className="lbl"><Fa name='repeat' />&nbsp;Repeat</div>
                            <div style={{minWidth:300}}>{repeat}</div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <button className="btn btn-xs btn-danger pull-right" style={{marginLeft: 10, marginTop: 5 }}  onClick={() => this.props.delete(this.props.index)}><Fa name="times"/>&nbsp;Delete</button>
                        <button className="btn btn-xs btn-default pull-right" style={{marginLeft: 10, marginTop: 5 }} onClick={() => this.editToggle()}><Fa name="pencil"/>&nbsp;Edit</button>
                    </div>
                </div>



            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ScheduleBox.jsx